module.exports = __webpack_public_path__ + "static/media/three.05ed8f12.svg";